import { PlanFeature } from './plan-feature';
import { PlanLevel } from './plan-level';

export interface PlanDetails {
  description: string;
  everythingText: string;
  features: PlanFeature[];
  featuresExtended?: PlanFeature[];
}

export const PlanSubscriptionDetails: Record<PlanLevel, PlanDetails> = {
  [PlanLevel.Freemium]: {
    description: `For teams just starting their journey.`,
    everythingText: 'Everything you need to get started!',
    features: [
      {
        title: 'Vision Traction Organizer' + '\u00AE' + '(V/TO' + '\u00AE' + ')',
        description: 'Vision Traction Organizer',
      },
      { title: 'Accountability Chart' + '\u00AE', description: 'Accountability Chart' },
      { title: 'Baseline & Org Fit Assessments', description: 'Baseline + Org Fit Assessments' },
      { title: 'EOS Toolbox' + '\u2122', description: 'EOS Toolbox' },
      { title: 'Knowledge Portal (Read Only)', description: 'Knowledge Portal (Read Only)' },
    ],
  },

  [PlanLevel.Essentials]: {
    description: `For teams focused on weekly execution.`,
    everythingText: `Everything in Free plus:`,

    features: [
      { title: 'L10 Meeting' + '\u00AE' + ' (Weekly Meeting)', description: 'L10 Weekly Meetings' },
      { title: 'Scorecard', description: '' },
      { title: 'Rocks', description: '' },
      { title: 'To-Dos', description: '' },
      { title: 'Issues', description: '' },
      { title: 'Google Task/Calendar Integrations', description: '' },
      { title: 'Microsoft Task/Calendar Integrations', description: '' },
    ],
  },

  [PlanLevel.Accelerate]: {
    description: `For strategic planning and team performance.`,
    everythingText: `Everything in ${PlanLevel.Essentials} plus:`,

    features: [
      { title: 'Insights', description: '' },
      { title: 'Custom Meetings', description: '' },
      { title: 'Quarterly & Annual Meetings', description: '' },
      { title: 'Quarterly & Annual Reviews', description: '' },
      { title: 'People Analyzer' + '\u00AE' + ' (Beta)', description: '' },
      { title: 'monday.com integration', description: '' },
    ],
  },

  [PlanLevel.Thrive]: {
    description: `For high-performing teams ready to scale.`,
    everythingText: `Everything in Accelerate plus:`,
    features: [
      { title: 'AI Rock Companion', description: '' },
      { title: 'AI Meeting Prep (Beta)', description: '' },
      { title: 'Knowledge Portal', description: '' },
      { title: 'Documentation & Processes', description: '' },
      { title: 'Custom Assessments (Beta)', description: '' },
    ],
  },
};
